import { Navigate, useLocation } from "react-router";

interface CheckAuthProps {
  isAuthenticated: boolean;
  children?: React.ReactNode;
}

const CheckAuth = ({ isAuthenticated, children }: CheckAuthProps) => {
  const location = useLocation();

  if (!isAuthenticated && !location.pathname.includes("/login")) {
    return <Navigate to="/login" replace />;
  }

  if (isAuthenticated && location.pathname.includes("/login")) {
    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
};

export default CheckAuth;
